import classNames from 'classnames';

import { iconDefaults } from '.';
import { IconProps as Props } from '../types/hubInterfaces';

function TicketIcon(props: Props) {
  const { width, height, className } = { ...iconDefaults, ...props };
  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className)}
    >
      <path d="M4.22222 5.25C2.99653 5.25 2 6.25898 2 7.5V9.75C2 10.0594 2.25694 10.302 2.54514 10.4039C3.19792 10.6324 3.66667 11.2617 3.66667 12C3.66667 12.7383 3.19792 13.3676 2.54514 13.5961C2.25694 13.698 2 13.9406 2 14.25V16.5C2 17.741 2.99653 18.75 4.22222 18.75H19.7778C21.0035 18.75 22 17.741 22 16.5V14.25C22 13.9406 21.7431 13.698 21.4549 13.5961C20.8021 13.3676 20.3333 12.7383 20.3333 12C20.3333 11.2617 20.8021 10.6324 21.4549 10.4039C21.7431 10.302 22 10.0594 22 9.75V7.5C22 6.25898 21.0035 5.25 19.7778 5.25H4.22222ZM6.44444 9.1875V14.8125C6.44444 15.1219 6.69444 15.375 7 15.375H17C17.3056 15.375 17.5556 15.1219 17.5556 14.8125V9.1875C17.5556 8.87812 17.3056 8.625 17 8.625H7C6.69444 8.625 6.44444 8.87812 6.44444 9.1875ZM5.33333 8.625C5.33333 8.00273 5.82986 7.5 6.44444 7.5H17.5556C18.1701 7.5 18.6667 8.00273 18.6667 8.625V15.375C18.6667 15.9973 18.1701 16.5 17.5556 16.5H6.44444C5.82986 16.5 5.33333 15.9973 5.33333 15.375V8.625Z" />
    </svg>
  );
}

export { TicketIcon };
